module.exports = __webpack_public_path__ + "static/media/pictures.90cafd30.GIF";